class MobileDrawerMenu extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      menuContainer: '[js-nav-container]',
      menus: '[js-nav-menu]',
      triggers: '[js-trigger]',
      closeBtn: '.close-btn',
      backBtn: '.back-btn'
    }

    this._init();
  }

  _init(){
    this.container = this.querySelector(this._selectors.menuContainer);
    this.triggers = this.querySelectorAll(this._selectors.triggers);
    this.menus = this.querySelectorAll(this._selectors.menus);
    this.closeBtn = this.querySelector(this._selectors.closeBtn);
    this.backBtn = this.querySelector(this._selectors.backBtn);
    this._setListeners();
    this._getScreenWidth();

    // Initial button state based on current index
    this._toggleButtons();
  }

  _getScreenWidth = () => {
    this.screenWidth = window.innerWidth
    document.documentElement.style.setProperty('--screen-width', `${window.innerWidth}px`)
  }

  _setListeners = () => {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this._changeMenu)
    })
    
    document.addEventListener('MobileNavDrawer:close', () => {
      this._slideMenu(0, '');
    })

    window.addEventListener('resize', this._getScreenWidth)
  }

  _changeMenu = (e) => {
    const trigger = e.currentTarget
    const direction = trigger.getAttribute('data-direction');
    const targetNav = trigger.getAttribute('data-target');
    let header = trigger.getAttribute('data-target-title');
    let targetIndex = parseInt(this.container.getAttribute('data-index'));

    if (direction === 'next') {
      targetIndex += 1;
      const targetMenu = this.querySelector(`${this._selectors.menus}[data-id=${targetNav}]`);
      const targetSiblings = theme.utils.getSiblings(targetMenu, this._selectors.menus);
      targetMenu.classList.remove('hidden');
      targetSiblings.forEach(sibling => {
        sibling.classList.add('hidden');
      })
      this.backBtn.setAttribute('data-target-title', header)
    } else {
      targetIndex -= 1;
    }

    this._slideMenu(targetIndex, header);
  }

  _slideMenu = (index, title) => {
    this.container.style.setProperty('--index', index)
    this.container.setAttribute('data-index', index)

    // Update button visibility based on the new index
    this._toggleButtons();
  }

  _toggleButtons = () => {
    const currentIndex = parseInt(this.container.getAttribute('data-index'));

    if (currentIndex === 0) {
      this.closeBtn.style.display = 'block';
      this.backBtn.style.display = 'none';
    } else if (currentIndex === 1) {
      this.closeBtn.style.display = 'none';
      this.backBtn.style.display = 'block';
    } else {
      this.closeBtn.style.display = 'none';
      this.backBtn.style.display = 'none';
    }
  }
}

customElements.define("nav-drawer-menu", MobileDrawerMenu);
